import React from 'react';

const Beneficios = () => {
  return (
    <div id="beneficios" className="mt-10 mb-10 bg-slate-900 flex flex-col items-center justify-center text-white px-4">
      {/* Descripción general */}
      <p className="text-lg text-purple-300 text-center max-w-2xl mb-8">
        Los audiolibros y las tecnologías accesibles no solo abren puertas al conocimiento, sino que también transforman vidas. Conoce cómo nuestras herramientas pueden mejorar tu experiencia.
      </p>
      {/* Lista de beneficios */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl w-full">
        {/* Beneficio 1 */}
        <div className="bg-slate-950 p-6 rounded-xl border border-purple-400/30 hover:border-purple-400/60 transition-all duration-300">
          <h2 className="text-xl font-semibold text-purple-400 mb-4">Accesibilidad</h2>
          <p className="text-purple-200">
            Nuestros recursos están diseñados para ser completamente accesibles, asegurando que todos puedan disfrutar del contenido sin limitaciones.
          </p>
        </div>
        {/* Beneficio 2 */}
        <div className="bg-slate-950 p-6 rounded-xl border border-purple-400/30 hover:border-purple-400/60 transition-all duration-300">
          <h2 className="text-xl font-semibold text-purple-400 mb-4">Inmersión en Historias</h2>
          <p className="text-purple-200">
            Los audiolibros permiten una experiencia inmersiva que te transporta a nuevos mundos, estimulando la imaginación y el aprendizaje.
          </p>
        </div>
        {/* Beneficio 3 */}
        <div className="bg-slate-950 p-6 rounded-xl border border-purple-400/30 hover:border-purple-400/60 transition-all duration-300">
          <h2 className="text-xl font-semibold text-purple-400 mb-4">Tecnología Innovadora</h2>
          <p className="text-purple-200">
            Utilizamos tecnologías avanzadas para garantizar que nuestros recursos sean intuitivos, eficientes y adaptables a tus necesidades.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Beneficios;